import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DimensionAccordion, DimensionPanel } from "../dashboard";
const css = `
.controls-layout {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    gap: 8px;
    pointer-events: none;
}

.controls-layout > * {
    pointer-events: all;
}

.controls-layout__calculate {
    width: 100%;
    height: 42px;
    border-radius: 12px;
    background: linear-gradient(135deg, #2563eb, #1e40af);
    border: 1px solid rgba(255,255,255,0.2);
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    cursor: pointer;
    box-shadow: 0 4px 16px rgba(37, 99, 235, 0.5);
    transition: transform 0.15s, box-shadow 0.15s, background 0.15s;
}

.controls-layout__calculate:hover {
    background: linear-gradient(135deg, #3b82f6, #2563eb);
    box-shadow: 0 6px 20px rgba(37, 99, 235, 0.7);
    transform: translateY(-1px);
}

.controls-layout__calculate:active {
    transform: translateY(0) scale(0.97);
    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.4);
}

/* Mobile layout — панель снизу, на всю ширину */
.controls-layout--mobile {
    position: static;
    width: 100%;
    flex-direction: column;
    gap: 0;
}

.controls-layout--mobile .controls-layout__calculate {
    height: 48px;
    border-radius: 0;
    font-size: 13px;
    box-shadow: none;
    border: none;
    border-top: 1px solid rgba(255,255,255,0.1);
}

.controls-layout--mobile .controls-layout__calculate:hover {
    transform: none;
    box-shadow: none;
}
`;
export function ControlsLayout({ controls, onSave, onCalculate, isMobile, title, btnText, btnTextSave }) {
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: css }), _jsxs("div", { className: `controls-layout ${isMobile ? 'controls-layout--mobile' : ''}`, children: [isMobile
                        ? _jsx(DimensionAccordion, { controls: controls, onSave: onSave, btnText: btnTextSave })
                        : _jsx(DimensionPanel, { controls: controls, onSave: onSave, btnText: btnTextSave, title: title }), onCalculate && (_jsx("button", { className: "controls-layout__calculate", onClick: onCalculate, children: btnText }))] })] }));
}
